/* Maison Sahari v3 - héros : diaporama (fondu, pause, indicateurs). Sans dépendance. */
(function () {
  'use strict';
  var FADE = 1300;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var design = document.documentElement.classList.contains('shopify-design-mode');

  function ready(img, fn) {
    if (!img || (img.complete && img.naturalWidth)) { fn(); return; }
    var done = false;
    function once() { if (done) return; done = true; fn(); }
    img.addEventListener('load', once, { once: true });
    img.addEventListener('error', once, { once: true });
    setTimeout(once, 2500);
  }

  function init(root) {
    if (root.__msHero) return;
    root.__msHero = true;
    var slides = [].slice.call(root.querySelectorAll('.ms-h3__slide'));
    var n = slides.length;
    var dots = [].slice.call(root.querySelectorAll('.ms-h3__dot'));
    var caps = [].slice.call(root.querySelectorAll('.ms-h3__cap-item'));
    var pauseBtn = root.querySelector('.ms-h3__pause');
    var live = root.querySelector('.ms-h3__slides');
    var cur = 0;
    var timers = [];
    var flags = { user: false, hover: false, focus: false, off: false };
    var loaded = false;

    function reduced() { return !!(mq && mq.matches); }
    function playing() { return n > 1 && !reduced() && !design; }

    function sync() {
      if (playing()) root.setAttribute('data-playing', ''); else root.removeAttribute('data-playing');
      var paused = flags.user || flags.hover || flags.focus;
      root.classList.toggle('is-paused', paused);
      root.classList.toggle('is-offscreen', flags.off);
      if (live) live.setAttribute('aria-live', playing() && !paused ? 'off' : 'polite');
    }

    function loadAll() {
      if (loaded) return;
      loaded = true;
      slides.forEach(function (s) {
        var img = s.querySelector('img[data-src]');
        if (!img) return;
        img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      });
    }

    function show(i) {
      if (i === cur) return;
      var prev = cur;
      cur = i;
      slides[prev].classList.remove('is-active');
      slides[prev].classList.add('is-leaving');
      slides[prev].setAttribute('aria-hidden', 'true');
      clearTimeout(timers[prev]);
      timers[prev] = setTimeout(function () { slides[prev].classList.remove('is-leaving'); }, FADE);
      clearTimeout(timers[i]);
      slides[i].classList.remove('is-leaving');
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      caps.forEach(function (c, k) {
        c.classList.toggle('is-active', k === i);
        if (c.tagName === 'A') {
          if (k === i) { c.removeAttribute('tabindex'); c.removeAttribute('aria-hidden'); }
          else { c.setAttribute('tabindex', '-1'); c.setAttribute('aria-hidden', 'true'); }
        }
      });
    }

    function go(i) {
      i = (i + n) % n;
      if (i === cur) return;
      loadAll();
      ready(slides[i].querySelector('img'), function () { show(i); });
    }

    if (n > 1) {
      /* Chargement différé des images 2 et 3, après le chargement de la page */
      var kick = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(loadAll); };
      if (design) loadAll();
      else if (document.readyState === 'complete') kick();
      else window.addEventListener('load', kick, { once: true });

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); });
        d.addEventListener('keydown', function (e) {
          var t = -1;
          if (e.key === 'ArrowRight') t = (k + 1) % n;
          else if (e.key === 'ArrowLeft') t = (k - 1 + n) % n;
          else if (e.key === 'Home') t = 0;
          else if (e.key === 'End') t = n - 1;
          if (t < 0) return;
          e.preventDefault();
          go(t);
          dots[t].focus();
        });
      });

      /* La fin de l'animation du filet actif déclenche l'image suivante : pause = animation suspendue */
      root.addEventListener('animationend', function (e) {
        if (e.animationName === 'ms-h3-fill' && playing()) go(cur + 1);
      });

      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { flags.hover = true; sync(); } });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { flags.hover = false; sync(); } });
      root.addEventListener('focusin', function (e) {
        var vis = true;
        try { vis = e.target.matches(':focus-visible'); } catch (err) { vis = true; }
        if (vis) { flags.focus = true; sync(); }
      });
      root.addEventListener('focusout', function () { flags.focus = false; sync(); });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          flags.user = !flags.user;
          pauseBtn.setAttribute('aria-pressed', flags.user ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute(flags.user ? 'data-label-play' : 'data-label-pause'));
          sync();
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          flags.off = !entries[entries.length - 1].isIntersecting;
          sync();
        }, { threshold: 0.15 }).observe(root);
      }
    }

    if (mq && mq.addEventListener) mq.addEventListener('change', sync);
    sync();
  }

  /* Hauteur de l'en-tête (annonce + barre) : posée par la section au chargement, recalculée seulement au redimensionnement */
  var rt;
  function measure() {
    var h = document.getElementById('header-group');
    if (!h) return;
    var t = 0;
    for (var i = 0; i < h.children.length; i++) t += h.children[i].offsetHeight;
    if (t > 0) [].forEach.call(document.querySelectorAll('[data-ms-hero]'), function (r) { r.style.setProperty('--h3-hdr', t + 'px'); });
  }
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });

  function boot() { [].forEach.call(document.querySelectorAll('[data-ms-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();